export default "__VITE_ASSET__BzlNNh_O__"